module.exports = __webpack_public_path__ + "09fd20329a241fbc1c0db9cf07c9bad4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-pirate-s.png
// module id = 2272
// module chunks = 0